import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import QRCode from "react-qr-code";
import Button from '@material-ui/core/Button';
import { Box, LinearProgress } from '@material-ui/core';

import {
  selectAuthenticatedError,
  selectAuthenticatedErrorMessage,
  selectIsAuthenticated,
  selectIsLoading, selectIsWaiting,
  selectLogin,
  selectWebToken,
  selectUserLogged,
  selectQRCode,
  selectIsCheckingLogin
} from '../../state/auth/auth.selectors';
import { doLogin, checkLogin, cancelCheckLogin, getQRCode } from '../../state/auth/auth.actions';
import HooliLogo from '../../components/HooliLogo';
import Loading from '../../components/Loading';
import { getCookie } from '../../utils/session';
class Login extends Component {
  constructor() {
    super();
    this.state = {
      locationObtained: false,
      lat: '',
      lng: '',
      attempts: 0,
      doc: '',
      QRCODE: null
    }
  }

  componentDidMount() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(pos => {
        this.setState({ locationObtained: true, lat: pos.coords.latitude.toFixed(6), lng: pos.coords.longitude.toFixed(6) })
      }, console.error);
    }
  }

  stopInterval() {
    this.setState({ attempts: 0 });
    if (this.interval) clearInterval(this.interval);
  }

  getQRCode() {
    const { getQRCode } = this.props;
    getQRCode(this.state.lat, this.state.lng);
  }

  componentDidUpdate(prevProps, prevState) {
    const { isWaiting, qrCode, isCheckingLogin, checkLogin } = this.props;
  
    if (prevProps.isWaiting !== isWaiting && isWaiting) {
      this.interval = setInterval(() => {
        this.setState(state => ({ attempts: state.attempts + (60 / 580 >= 100 ? 100 : 60 / 580) }));
        if (this.state.attempts >= 106) {
          this.stopInterval();
        }
      }, (60 / 580) * 1000);
    } else if (!isWaiting && this.interval) {
      clearInterval(this.interval);
    }
  
    if (qrCode && !isCheckingLogin && prevProps.qrCode !== qrCode) {
      checkLogin({qrCode,lat:this.state.lat, lng: this.state.lng});
    } else if (!qrCode) {
      this.getQRCode();
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }


  renderWhenQRCodeIsNotAvalibale = ()=> { 
     const { qrCode } = this.props
     return (
            <Fragment>
              <Box mb={5}> 
              <h1 id='title'>Hola!</h1>
              <h4 id='subtitle'>Para poder ingresar, escanea el QR desde la App de Hooli.</h4>
              </Box>
               
               <QRCode value={qrCode} />
               <LinearProgress
                variant="determinate"
                value={this.state.attempts}
                 style={{ width: '100%', marginTop: '16px' }}
                />
      </Fragment>
        )
  }

  renderWhenQRCodeExpired = ()=> {
    return (
      <Fragment> 

           <Box> 
            <h4 id='title'>Ups!</h4>
            <p id='subtitle'>El código caducó, generá un <span>nuevo QR</span> para poder ingresar.</p>
           </Box>

           <Box mb={10} mt={8}> 
             <img id='logo-image' src='images/icon/hooli-icon.png' alt='logo-hooli'/>
          </Box>

          <Box width={"100%"} >  
            <Button 
               onClick={()=>this.getQRCode()} 
               variant='standart' 
               style={{
                backgroundColor:"#5567AE",
                borderRadius:"5px",
                 width:"100%",
                color:"#FFFF"
              }}>
                Generar nuevo QR
            </Button>

          </Box>
        
        
      </Fragment>
    )
  }
  
  render() {
    const { isAuthenticated,qrCode, isCheckingLogin } = this.props;
    const path = getCookie('redirect') || ''; 
  

    return !isAuthenticated ? (
      <Fragment>
        <Box width={"100%"} display={"flex"} justifyContent={"center"} alignItems={"center"} mb={3}> 
            <HooliLogo />
        </Box>
        
        <Box height={"350px"} width={"400px"} bgcolor={"#FAFAFA"} display={"flex"} justifyContent={"center"} flexDirection={"column"} alignItems={"center"} padding={5} borderRadius={"20px"}> 
        {!qrCode && !isCheckingLogin && (<Loading show />)}
        { qrCode && isCheckingLogin && this.renderWhenQRCodeIsNotAvalibale()} 
       { qrCode && !isCheckingLogin && this.renderWhenQRCodeExpired()} 

        </Box>
      
      </Fragment>
    ) : <Redirect to={path} />;
  }
}

const mapStateToProps = state => ({
  authenticatedError: selectAuthenticatedError(state),
  authenticatedErrorMessage: selectAuthenticatedErrorMessage(state),
  isAuthenticated: selectIsAuthenticated(state),
  isLoading: selectIsLoading(state),
  login: selectLogin(state),
  isWaiting: selectIsWaiting(state),
  webToken: selectWebToken(state),
  userLogged: selectUserLogged(state),
  qrCode: selectQRCode(state),
  isCheckingLogin: selectIsCheckingLogin(state)
});

const actions = {
  doLogin,
  checkLogin,
  cancelCheckLogin,
  getQRCode
};

export default connect(mapStateToProps, actions)(Login);



// WEBPACK FOOTER //
// ./src/pages/Login/index.js